var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { isPresent, isNone } from '@ember/utils';
import { attr, belongsTo } from '@ember-data/model';
import { A } from '@ember/array';
import { fragmentArray, array } from 'ember-data-model-fragments/attributes';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { CATALOG_SERVICE_TEMP_TOKEN_PREFIX } from '@square/dashboard-data/models/catalog/catalog-service-constants';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { itemSubunitsServiceActiveSubunits, itemSubunitsServiceAllSubunits } from '@square/dashboard-utilities/utils/item-subunits';
// @ts-expect-error: missing types
import { recordIdentifierFor } from '@ember-data/store';
export const MAX_PRECISION = 5;
export const DEFAULT_PRECISION = 3;
export const MAX_ABBREVIATION_LENGTH = 5;
export const MAX_CUSTOM_TYPE_NAME_LENGTH = 255;
export let CatalogObjectType = /*#__PURE__*/function (CatalogObjectType) {
  CatalogObjectType["ITEM"] = "ITEM";
  CatalogObjectType["IMAGE"] = "IMAGE";
  CatalogObjectType["CATEGORY"] = "CATEGORY";
  CatalogObjectType["ITEM_VARIATION"] = "ITEM_VARIATION";
  CatalogObjectType["TAX"] = "TAX";
  CatalogObjectType["DISCOUNT"] = "DISCOUNT";
  CatalogObjectType["MODIFIER"] = "MODIFIER";
  CatalogObjectType["MODIFIER_LIST"] = "MODIFIER_LIST";
  CatalogObjectType["MODIFIER_LIST_INFO"] = "MODIFIER_LIST_INFO";
  CatalogObjectType["MODIFIER_OVERRIDE"] = "MODIFIER_OVERRIDE";
  CatalogObjectType["PRICING_RULE"] = "PRICING_RULE";
  CatalogObjectType["PRODUCT_SET"] = "PRODUCT_SET";
  CatalogObjectType["TIME_PERIOD"] = "TIME_PERIOD";
  CatalogObjectType["MEASUREMENT_UNIT"] = "MEASUREMENT_UNIT";
  CatalogObjectType["SUBSCRIPTION_PLAN"] = "SUBSCRIPTION_PLAN";
  CatalogObjectType["SUBSCRIPTION_PLAN_VARIATION"] = "SUBSCRIPTION_PLAN_VARIATION";
  CatalogObjectType["SUBSCRIPTION_PRODUCT"] = "SUBSCRIPTION_PRODUCT";
  CatalogObjectType["ITEM_OPTION"] = "ITEM_OPTION";
  CatalogObjectType["ITEM_OPTION_VAL"] = "ITEM_OPTION_VAL";
  CatalogObjectType["CUSTOM_ATTRIBUTE_DEFINITION"] = "CUSTOM_ATTRIBUTE_DEFINITION";
  CatalogObjectType["CHECKOUT_LINK"] = "CHECKOUT_LINK";
  CatalogObjectType["ADDRESS"] = "ADDRESS";
  CatalogObjectType["TAG"] = "TAG";
  CatalogObjectType["MENU"] = "MENU";
  CatalogObjectType["AVAILABILITY_PERIOD"] = "AVAILABILITY_PERIOD";
  CatalogObjectType["ITEM_VARIATION_VENDOR_INFO"] = "ITEM_VARIATION_VENDOR_INFO";
  CatalogObjectType["AGE_RESTRICTION"] = "AGE_RESTRICTION";
  CatalogObjectType["VOID_REASON"] = "VOID_REASON";
  CatalogObjectType["SALE_PRICE"] = "SALE_PRICE";
  CatalogObjectType["SERVICE_CHARGE"] = "SERVICE_CHARGE";
  CatalogObjectType["CATALOG_CONFIGURATION"] = "CATALOG_CONFIGURATION";
  CatalogObjectType["COMPOSITION"] = "COMPOSITION";
  CatalogObjectType["COMPONENT"] = "COMPONENT";
  CatalogObjectType["COMBO_SLOT"] = "COMBO_SLOT";
  return CatalogObjectType;
}({});
let CatalogObject = (_dec = attr('string', {
  protoEnum: CatalogObjectTypeProto
}), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = fragmentArray('connect/catalog-v1-id'), _dec5 = attr('boolean', {
  allowNull: true,
  defaultValue: true
}), _dec6 = array(), _dec7 = array(), _dec8 = belongsTo('connect/image', {
  async: false
}), _dec9 = fragmentArray('connect/custom-attribute-value'), _class = class CatalogObject extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor2, this);
    _initializerDefineProperty(this, "version", _descriptor3, this);
    _initializerDefineProperty(this, "catalogV1Ids", _descriptor4, this);
    _initializerDefineProperty(this, "presentAtAllLocations", _descriptor5, this);
    _initializerDefineProperty(this, "presentAtLocationIds", _descriptor6, this);
    _initializerDefineProperty(this, "absentAtLocationIds", _descriptor7, this);
    _initializerDefineProperty(this, "image", _descriptor8, this);
    _initializerDefineProperty(this, "customAttributeValues", _descriptor9, this);
  }
  get globallyEnabled() {
    return this.presentAtAllLocations;
  }

  // `globallyEnabled` essentially functions as the default value for whether an individual location is enabled.
  // When setting the attribute, we need to update `presentAtLocationIds` and `absentAtLocationIds`
  // accordingly so that we preserve each location's `enabledForUnit` value.
  set globallyEnabled(value) {
    if (this.presentAtAllLocations === value) {
      return;
    }
    const activeSubunitTokens = itemSubunitsServiceActiveSubunits(true).mapBy('token');
    if (value) {
      const previouslyEnabledSubunitIds = new Set(this.presentAtLocationIds.toArray());
      this.absentAtLocationIds = A(activeSubunitTokens.filter(subunitToken => !previouslyEnabledSubunitIds.has(subunitToken)));
      this.presentAtLocationIds = A([]);
    } else {
      const previouslyDisabledSubunitIds = new Set(this.absentAtLocationIds.toArray());
      this.presentAtLocationIds = A(activeSubunitTokens.filter(subunitToken => !previouslyDisabledSubunitIds.has(subunitToken)));
      this.absentAtLocationIds = A([]);
    }
    this.presentAtAllLocations = value;
  }
  enabledForUnit(unitToken) {
    if (this.presentAtAllLocations) {
      return !this.absentAtLocationIds.includes(unitToken);
    }
    return this.presentAtLocationIds.includes(unitToken);
  }
  addMerchantSubunit(merchantSubunit) {
    this.addMerchantSubunits([merchantSubunit]);
  }
  addMerchantSubunits(merchantSubunits) {
    if (isPresent(merchantSubunits)) {
      const subunitTokens = new Set(merchantSubunits.map(subunit => subunit.token));
      const subunitsToAdd = itemSubunitsServiceAllSubunits().filter(subunit => subunitTokens.has(subunit.token));
      const subunitTokensToAdd = subunitsToAdd.map(subunit => subunit.token);
      if (!this.presentAtAllLocations) {
        this.presentAtLocationIds = A([...this.presentAtLocationIds.toArray(), ...subunitTokensToAdd.filter(token => !this.presentAtLocationIds.includes(token))]);
      }
      const newAbsentAtLocationIds = this.absentAtLocationIds.filter(token => !this.presentAtLocationIds.includes(token) && !subunitTokensToAdd.includes(token));
      if (this.absentAtLocationIds.length !== newAbsentAtLocationIds.length) {
        this.absentAtLocationIds = A(newAbsentAtLocationIds);
      }
    }
  }
  removeMerchantSubunit(subunitToken) {
    this.presentAtLocationIds = A(this.presentAtLocationIds.toArray().filter(token => token !== subunitToken));
    if (this.presentAtAllLocations) {
      const targetUnit = itemSubunitsServiceAllSubunits().find(subunit => subunit.token === subunitToken);
      if (!isNone(targetUnit)) {
        const currentAbsentAtLocationIds = this.absentAtLocationIds.toArray();
        if (!currentAbsentAtLocationIds.includes(subunitToken)) {
          currentAbsentAtLocationIds.push(subunitToken);
        }
        this.absentAtLocationIds = A(currentAbsentAtLocationIds);
      }
    }
  }
  get tempId() {
    const lid = recordIdentifierFor(this)?.lid;
    return CATALOG_SERVICE_TEMP_TOKEN_PREFIX + lid;
  }

  /*
  Our API expects newly created objects to have a temporary client id when saved. This id is used to reference
  the object in other objects saved in the same batch. This function also gives us a way to get a string reference
  to a model before it has been saved.
   When using this function in application code make sure to update references
  that might have a temp id after saving the referenced objects.
  */
  idOrTempId() {
    return this.id ?? this.tempId;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "catalogV1Ids", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "presentAtAllLocations", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "presentAtLocationIds", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "absentAtLocationIds", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "image", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "customAttributeValues", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CatalogObject as default };